import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  dateFormat,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { Link } from "react-router-dom";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import Slider from "react-slick";
import { Table1 } from "../../components/table/Table1";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { Table3 } from "../../components/table/Table3";
import { IoDocument } from "react-icons/io5";

const Product = () => {
  ChangeTitle("Product");
  const [mainMenu, setMainMenu] = useState("");
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(5);
  const [sortField, setSortField] = useState("created");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]); // All Data List
  const [tabMenuData, setTabMenuData] = useState([]);
  // const [data, setData] = useState([
  //   {
  //     category: "Law",
  //     law: "VAT Law",
  //     arabicName: "",
  //     chapter: "Law",
  //     product: "",
  //     entity: "",
  //     language: "Arabic",
  //     issueDate: "Not available",
  //     publishDate: "Not available",
  //     docNo: "Qm 09",
  //   },
  // ]); // All Data List

  // Products List Api call

  const viewProductsList = async (
    sortOrder,
    sortField,
    limit,
    offset,
    filter,
    search
  ) => {
    const param = {
      term: search,
      productcategoryId: filter || "",
      sort: sortOrder,
      sortBy: sortField,
      limit: limit,
      offset: offset,
    };

    var response = await postData(
      "private/product/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const totalRecords = response.data.data.totalRecord;
      setData(data);
      setTotalRecords(totalRecords);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  const viewProductCategoryList = async () => {
    const param = {
      limit: 0,
      offset: 0,
      term: "",
      sort: "",
      sortBy: "",
    };

    var response = await postData(
      "private/product/category/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setTabMenuData(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewProductCategoryList();
  }, []);

  useEffect(() => {
    viewProductsList(sortOrder, sortField, limit, offset, mainMenu,search);
  }, [sortOrder, sortField, limit, offset, mainMenu,search]);

  // table columns
  const columns = [
    {
      class: "min-w-[100px]",
      name: <label className="st-head-tr-th-text">Sr. no.</label>,
      cell: (row, rowIndex, baseIndex) => {
        const srNo = baseIndex + rowIndex + 1;
        return srNo;
      },
      sortable: false,
      field: "_id",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Category</label>,
      cell: (row) =>
        row.productcategoryDetail && row.productcategoryDetail.name,
      sortable: false,
      field: "productcategoryDetail.name",
    },
    {
      class: "min-w-[350px]",
      name: (
        <label className="st-head-tr-th-text">
          Law / Regulation / Decision name
        </label>
      ),
      cell: (row) => row.taxserviceDetail && row.taxserviceDetail.serviceName,
      sortable: false,
      field: "taxserviceDetail.serviceName",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Arabic name</label>,
      cell: (row) => row.arabicName,
      sortable: false,
      field: "arabicName",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Chapter</label>,
      cell: (row) => row.chapter,
      sortable: false,
      field: "chapter",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Product</label>,
      cell: (row) => row.product,
      sortable: false,
      field: "product",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Entity</label>,
      cell: (row) => row.entity,
      sortable: false,
      field: "entity",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Language</label>,
      cell: (row) => row.language,
      sortable: false,
      field: "language",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Issue date</label>,
      cell: (row) => dateFormat(row.issueDate),
      sortable: false,
      field: "issueDate",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Published date</label>,
      cell: (row) => dateFormat(row.publishDate),
      sortable: false,
      field: "publishDate",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Doc no</label>,
      cell: (row) =>
        row.docNo && (
          <a href={row.docNo} target="_blank">
            <IoDocument className="table-doc-icon" />
          </a>
        ),
      sortable: false,
      field: "docNo",
    },
  ];

  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setOffset(0); // Reset to the first page on sort change
    viewProductsList(newSortOrder, field, limit, offset, mainMenu);
  };

  //   const partnerSettings = {
  //     slidesPerRow: 1,
  //     slidesToShow: 6,
  //     slidesToScroll: 1,
  //     infinite: false,
  //     swipeToSlide: true,
  //     arrows: true,
  //     nextArrow: (
  //       <div>
  //         <div className="relative top-[-1.5rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max shadow-lg main-arrow main-arrow2">
  //           <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
  //             <IoMdArrowRoundForward className="text-4xl arrow" />
  //           </div>
  //         </div>
  //       </div>
  //     ),
  //     prevArrow: (
  //       <div>
  //         <div className="relative z-[10] top-[-2.5rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[-9rem] w-max shadow-lg main-arrow">
  //           <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
  //             <IoMdArrowRoundBack className="text-4xl arrow" />
  //           </div>
  //         </div>
  //       </div>
  //     ),
  //     responsive: [
  //       {
  //         breakpoint: 1440,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 976,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 640,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //         },
  //       },
  //     ],
  //   };

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="sec-product">
            <div className="relative z-[5] mb-[3rem] lg:mb-[-7rem] lg:w-[90%] xl:w-[70%] overflow-x-auto flex justify-evenly p-[1rem] md:p-[2rem] mx-auto product-main-menu">
              {/* <Slider
                className="h-max w-[90%] mx-auto flex cursor-pointer"
                {...partnerSettings}
              > */}
              <button
                className={
                  mainMenu == ""
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("")}
              >
                All
              </button>
              {tabMenuData.map((data) => (
                <button
                  className={
                    mainMenu == data._id
                      ? "product-box-active product-box"
                      : "product-box"
                  }
                  onClick={() => setMainMenu(data._id)}
                >
                  {data?.name}
                </button>
              ))}

              {/* <button
                className={
                  mainMenu === "Law"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Law")}
              >
                Law
              </button>
              <button
                className={
                  mainMenu === "Regulations"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Regulations")}
              >
                Regulations
              </button>
              <button
                className={
                  mainMenu === "Chairman Decision"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Chairman Decision")}
              >
                Chairman decision
              </button>
              <button
                className={
                  mainMenu === "Forums"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Forums")}
              >
                Forums
              </button>
              <button
                className={
                  mainMenu === "FAQ"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("FAQ")}
              >
                FAQ
              </button>
              <button
                className={
                  mainMenu === "Guides"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Guides")}
              >
                Guides
              </button>
              <button
                className={
                  mainMenu === "Royal Decree"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Royal Decree")}
              >
                Royal decree
              </button>
              <button
                className={
                  mainMenu === "Manual"
                    ? "product-box-active product-box"
                    : "product-box"
                }
                onClick={() => setMainMenu("Manual")}
              >
                Manual
              </button> */}
              {/* </Slider> */}
            </div>
            <Table3
              className="px-[3%] py-[3%] lg:pt-[10rem] mb-5 lg:mb-8"
              columns={columns}
              data={data || []}
              totalRecords={totalRecords}
              additionalField={""}
              searchPlaceholder="Search Product"
              searchValue={search}
              setSearchValue={(e) => {
                setSearch(e.target.value);
                setOffset(0);
              }}
              isSearch={true}
              limit={limit}
              offset={offset}
              setOffset={setOffset}
              isAllowAllList={true}
              setLimit={setLimit}
              sortField={sortField}
              sortOrder={sortOrder}
              handleSort={handleSort}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
